export const NET_SELL_LABEL = "Ventas netas";
export const GROSS_SELL_LABEL = "Ventas brutas";
